import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-nd': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8c141.8 0 248.4 110.1 248.4 248 0 147.1-118.5 248-248.4 248-134 0-247.6-109.5-247.6-248 0-132.9 104.7-248 247.6-248zM248.4 52.7c-118.2 0-203.7 97.9-203.7 203.3 0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8 0.1-113.8-90.2-203.3-202.8-203.3zM342.4 197v42.5h-180.3v-42.5h180.3zM342.4 276.8v42.5h-180.3v-42.5h180.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-nd.js
// module id = 770
// module chunks = 0